<template>
  <div>
    <vue-dropzone :id="'excelFile_' + index" ref="myDropzone" :options="dropzoneOptions"></vue-dropzone>
    <div v-if="uploadedFile">
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import * as XLSX from 'xlsx';
export default {
  data() {
    return {
      index: 0,
      questionData: {},
      dropzoneOptions: {
        url: '/', // Replace this with your backend API endpoint for handling file uploads
        method: "GET",
        maxFiles: 1,
        uploadMultiple: false,
        acceptedFiles: '.xlsx', // Limit to Excel files only
        addRemoveLinks: true,
        // headers: { "My-Awesome-Header": "header value" },
        dictDefaultMessage: "<strong class='dz-message'>Drop your Excel file here or click to upload</strong>",
      },
      uploadedFile: null,
      excelDataArray: null,
      stAnswerTextList:[],
      stAnswerTextListValidate:[]
    };
  },
  mounted() {
    this.initDropzone();
  },
  computed: {
    ...mapGetters("editquestionEdit", ["getSurveyQuestWithDetails","ExcelQuestionMasterId"]),
    
  },
  methods: {
    ...mapActions("editquestionEdit", ["setExcelDataArray", "addTagsDetails", "getQuestionAll"]),
    setQuestionData() {
      this.questionData.sessionData = this.$session.getAll();
      this.questionData.excelDataArray = this.excelDataArray;
    },

    initDropzone() {
      // Get a reference to the Dropzone instance
      const myDropzone = this.$refs.myDropzone.dropzone;

      myDropzone.on('addedfile', (file) => {
        const reader = new FileReader();
        reader.onload = () => {
          const fileContent = reader.result;
          this.parseExcelFile(fileContent);
        };
        reader.readAsBinaryString(file);
      });
    },

    parseExcelFile(fileContent) {
      const workbook = XLSX.read(fileContent, { type: 'binary' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const excelData = XLSX.utils.sheet_to_json(worksheet,  {defval: null,});
      this.excelDataArray = excelData;

      let surveyDataAll = this.getSurveyQuestWithDetails;
      let filterExcelData = surveyDataAll[this.ExcelQuestionMasterId]; 
      let hasKey = filterExcelData.hasOwnProperty('qval_6');
      if (hasKey) {
          let surveyData = filterExcelData['qval_6'];
          this.questionData.in_question_type_id = surveyData['in_question_type_id'];
            let surveyDataList = surveyData['st_answer_text'];
            let arrayOfList = surveyDataList.split('\n');
            arrayOfList.forEach(e => {
              this.stAnswerTextList.push(e);
            });
      } else {
          let surveyData = Object.values(filterExcelData['score_data']);
          this.questionData.in_question_type_id = filterExcelData['qval_14']['in_question_type_id'];
          surveyData.forEach(e => {
            this.stAnswerTextList.push(e.st_answer_text);
          });
      }
      this.excelDataArray.forEach(e => {
        this.stAnswerTextListValidate.push(e.Answers);
      });

      const checkAnswerValidation = JSON.stringify(this.stAnswerTextList) === JSON.stringify(this.stAnswerTextListValidate);
      if(checkAnswerValidation === true){
        this.setExcelDataArray(this.excelDataArray);
        this.setQuestionData();
        this.addTagsDetails(this.questionData);
        this.$awn.success("Answers data with Tags Details are Updated Successfully");
        this.stAnswerTextList = [];
        this.stAnswerTextListValidate = [];
      } else {
        this.$awn.alert("Make sure to upload right file for this Question, Wrong file uploaded!!!");
      }
      this.stAnswerTextList = [];
    },
  },
};
</script>
  


// WEBPACK FOOTER //
// src/components/Dashboard/RightBarComponents/ExcelFileDropzone.vue